// import barba from '@barba/core';

$(() => {

    //Loading Website
    function loadingPageStarter() {
        $('body').removeClass('wating-loading');

        if ($('body').hasClass('woocommerce-checkout')) {
            updateTotalHireProducts();
        }
    }
    $(window).on('load', loadingPageStarter);

    setTimeout(() => {
        loadingPageStarter();
    }, 500);

    //Menu
    $('.btn-close-menu').on('click', () => {
        $('#main-header > .not-show-in-closed').fadeOut(100);
        $('#main').css('margin-left', 68);
        $('#main-header').css('width', 68);
        closeSubmenu();

        setTimeout(() => {
            $('#main-header > .show-in-closed').fadeIn(100);
            $('#main-header').addClass('closed');
        }, 300);
    })

    $('.btn-open-menu').on('click', () => {

        $size = 310;

        if ($(window).width() <= 1300) {
            $size = 280;
        }


        $('#main').css('margin-left', $size);
        $('#main-header').css('width', $size);
        $('#main-header > *').fadeOut(100);

        setTimeout(() => {
            $('#main-header > .not-show-in-closed').fadeIn(100);
            $('#main-header').removeClass('closed');
        }, 300);

        $('#logo-menu-collapsed').fadeOut();
    });

    $('.btn-close-submenu').on('click', () => {
        // $('.submenu-slide').hide("slide", {
        //     direction: "left"
        // }, 1000);
        // $('.submenu-slide').hide("slide", {
        //     direction: 'left'
        // });
        closeSubmenu();
    });

    //Submenu
    $('.main-header .menu-item-link').on('click', (e) => {
        $menu_id = $(e.currentTarget).attr('menu-id');

        $submenu = $('#submenu-slide-' + $menu_id);

        if ($submenu.length == 1 && !$submenu.hasClass('open')) {
            e.preventDefault();
            $submenuWidth = $('#main-header').width();
            $submenu.animate({
                width: $submenuWidth
            }, "fast");

            $submenu.addClass('open');

            $('#submenu-slide-' + $menu_id + ' > *').fadeIn(600);
        }
    })

    function closeSubmenu() {

        $(".submenu-slide").animate({
            width: 0
        }, "fast");

        $(".submenu-slide > *").fadeOut(100);

        $(".submenu-slide").removeClass('open');

        $('#logo-menu-collapsed').fadeIn();
    }

    //Menu Mobile
    $('.mobile-menu-hamburger').on('click', () => {
        if ($('.mobile-menu').hasClass('open')) {
            $('.mobile-menu').removeClass('open');
        } else {
            $('.mobile-menu').addClass('open');
        }
    })

    //Testimonial
    $('.testimonials-loop').slick({
        dots: false,
        draggable: true,
        adaptiveHeight: false,
        infinite: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 10000,
        pauseOnHover: true,
        appendArrows: $('.section-testimonials'),
        prevArrow: '<div class="testimonial-button testimonial-prev transition-all" ></div>',
        mobileFirst: true,
        nextArrow: '<div class="testimonial-button testimonial-next transition-all" ></div>',
        responsive: [{
            breakpoint: 1024,
            settings: {
                arrows: false,
                prevArrow: false,
                nextArrow: false,
            },
        }],
    });

    //Instagram
    $('.instagram-feed-loop').slick({
        dots: false,
        draggable: true,
        adaptiveHeight: false,
        infinite: true,
        slidesToShow: 3,
        arrows: true,
        autoplay: false,
        appendArrows: $('.instagram-feed'),
        prevArrow: '<div class="instagram-feed-button instagram-feed-prev" ></div>',
        nextArrow: '<div class="instagram-feed-button instagram-feed-next" ></div>',
        responsive: [{
            breakpoint: 1024,
            settings: {
                arrows: false,
                prevArrow: false,
                nextArrow: false,
                slidesToShow: 2,
            },
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                arrows: false,
            },
        }],
    })

    //Product Quantity
    var realQty = $('form.cart .input-text.qty.text');
    $('.qty-real-time .change-qty').on('click', e => {
        var input = $('#qty-real-time-input');
        var qty = parseInt(input.val());

        if ($(e.currentTarget).hasClass('up')) {
            qty++;
        } else {
            qty--;
        }

        if (qty < 1) {
            qty = 1;
        }

        realQty.val(qty);

        input.val(qty);

        updatePrice(qty);
    });

    $('#qty-real-time-input').on('keyup', () => {
        updatePrice()
    });

    function updatePrice(qty = false) {

        var price = $('#wc-product-price');

        if (!qty) {
            qty = $('#qty-real-time-input').val();
        }

        var newPrice = qty * parseFloat(price.attr('data-price'));

        price.html(newPrice.toFixed(2));
    }

    //
    $('.pa-color-picker-variation-loop-item').on('click', e => {
        $('#pa_color').val($(e.currentTarget).attr('data-slug')).change();

        $('.pa-color-picker-variation-loop-item').removeClass('current');
        $('#single-product-gallery-main').attr('src', $(e.currentTarget).attr('data-src'));
        $(e.currentTarget).addClass('current');
    })

    //Update Price in checkout after update Book dates
    $('#order_hire_book_from').on('change', updateTotalHireProducts);
    $('#order_hire_book_to').on('change', updateTotalHireProducts);
    $('input[name="shipping_method[0]"]').on('change', updateTotalHireProducts);

    function updateTotalHireProducts() {

        // const $from = $('#order_hire_book_from').val();
        const $to = $('#order_hire_book_to').val();

        const qty = $to;
        // const diffTime = Math.abs(to - from);
        // var qty = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        // qty = qty == 0 ? 1 : qty;

        if (qty > 0) {

            var newPrice = qty * parseFloat($('#total-cart-hire').attr('data-price'));

            //Total cost for hire items
            $('#total-cart-hire td').html(qty + 'x $ ' + newPrice.toFixed(2));

            //Subtotal
            var subtotal = newPrice;

            $('.plus-to-the-total').each(function (index, element) {
                subtotal += parseFloat($(element).attr('data-price'));
            });

            $('#cart-subtotal-modifier').html('$ ' + subtotal.toFixed(2));

            //Shipping
            var shippingPrice = 0;
            if ($('.shipping_method:checked').attr('cost')) {
                shippingPrice = parseFloat($('.shipping_method:checked').attr('cost'));

                if ($('.shipping_method:checked').attr('method') == 'local_pickup') {
                    $('#billing_address_title').fadeOut();
                    $('#billing_address_1_field').fadeOut();
                    $('#billing_city_field').fadeOut();
                    $('#billing_postcode_field').fadeOut();
                    $('#billing_state_field').fadeOut();
                } else {
                    $('#billing_address_title').fadeIn();
                    $('#billing_address_1_field').fadeIn();
                    $('#billing_city_field').fadeIn();
                    $('#billing_postcode_field').fadeIn();
                    $('#billing_state_field').fadeIn();
                }
            }

            //GST
            // var gst = $('#cart-tax-modifier');
            // var gsttotal = (subtotal * parseFloat(gst.attr('data-price'))) / 100;

            // gst.html('$ ' + gsttotal.toFixed(2));

            //Total
            $('#cart-total-modifier').html('<strong>$ ' + (shippingPrice + subtotal).toFixed(2) + '</strong>')
        }
    }
});